import { Component, OnInit } from '@angular/core';
import { Role } from '../../requets/shared/model/Role.model';
import { RoleInformation } from 'src/app/core/shared/role-information.model';
import { BossDependence } from '../../requets/shared/model/boss-dependence.model';
import { FilterRequest } from '../../requets/shared/model/filter-request.model';
import { UserService } from '../../requets/shared/user.service';
import { UtilityService } from 'src/app/core/shared/utility.service';
import { Router } from '@angular/router';
import { EndorsesService } from '../shared/endorses.service';
import { RequestEndorse } from '../shared/request-endorse.model';

@Component({
  selector: 'app-endorse',
  templateUrl: './endorse.component.html',
  styleUrls: ['./endorse.component.scss']
})
export class EndorseComponent implements OnInit {
  roles: Role[] = [];
  viceFaculty: any;
  bossDeependence: BossDependence;
  currentRol: Role;
  tipoRol: number;
  enabledSpinner = false;
  isPifle = false;
  fileSearch: FilterRequest;
  rolesApplication: Role[] = [];
  Requests: RequestEndorse[];

  constructor(private userService: UserService,
              private utilityService: UtilityService,
              private endorseService: EndorsesService,
              private router: Router) { }

  ngOnInit() {
    this.getUserInformation();
  }

  private getUserInformation() {
    const userid =  null;
    const cedula =  localStorage.getItem('cedula');
    this.userService.getUserInformation(userid, cedula).subscribe(
      (result) => {
        if (result.data) {
            this.roles =  result.data.roles as Role[];
            this.bossDeependence = result.data.jefeDepartamento as BossDependence;
            this.viceFaculty = result.data.vice.facultad;
            const roleInformation: RoleInformation = this.utilityService.validateRole(this.roles, 2);
            this.rolesApplication = roleInformation.roles;
            this.currentRol = roleInformation.currentRol;
            this.tipoRol = roleInformation.tipoValidation;
            if ( this.tipoRol === 0) {
              const parameters = {
                tipo: 'info',
                mensaje: 'Usted no posee el rol adecuado para acceder a esta opción'
              };
              this.router.navigate(['message'], {queryParams : parameters});
            }
            this.generateFirstSearch();
        }
      }
    );
  }

  sendFilter(event: FilterRequest) {
    event.tipoResultado = 2;
    this.enabledSpinner = true;
    this.fileSearch = event;
    this.isPifle = this.fileSearch.tipo === 'PRUEBA LENGUA EXTRANJERA' ? true : false;
    const cedula = localStorage.getItem('cedula');
    this.Requests = [];
    this.endorseService.getRequets(cedula, this.fileSearch.tipo ).subscribe(
      (result) => {
        this.enabledSpinner = false;
        if (result.data) {
          this.Requests = result.data as RequestEndorse[];
          if (event.tipo) {
            this.Requests = this.Requests.filter( sub =>  sub.tipo === event.tipo);
          }
          if (event.facultad) {
            this.Requests = this.Requests.filter( sub =>  sub.facultad.split(' ')[0] === event.facultad + '');
          }
          if (event.programa) {
            this.Requests = this.Requests.filter( sub =>  sub.codPrograma === event.programa + '');
          }
          if (event.cedula) {
            this.Requests = this.Requests.filter( sub =>  sub.estudiante.split(' ')[0] === event.cedula + '');
          }
        }
        this.enabledSpinner = false;
      }
    );
  }

  private generateFirstSearch() {
    const filterRequest = new FilterRequest();
    if (this.tipoRol === 1) {
        filterRequest.tipo = 'MATERIA REGULAR';
    } else {
      filterRequest.tipo = 'MATERIA LENGUA EXTRANJERA';
    }
    this.sendFilter(filterRequest);
  }

}
